import { type DOMKeyframesDefinition, useAnimate } from 'framer-motion';
import {
  type AnimationOptions,
  type AnimationPlaybackControlsWithThen,
  type AnimationScope,
  type ElementOrSelector,
} from 'motion-dom';

interface DiceBoardDataReturnType {
  scope: AnimationScope<HTMLDivElement>;
  animate: (
    element: ElementOrSelector,
    keyframes: DOMKeyframesDefinition,
    options?: AnimationOptions,
  ) => AnimationPlaybackControlsWithThen;
}

const useDiceBoardData = (): DiceBoardDataReturnType => {
  const [scope, animate] = useAnimate<HTMLDivElement>();

  return {
    scope,
    animate,
  };
};

export { type DiceBoardDataReturnType, useDiceBoardData };
